import React from 'react'
import styled from 'styled-components'

import Benefits from 'pages/paywall/Benefits'
import PlanSelection from 'pages/paywall/PlanSelection'
import PremiumSelection from 'pages/paywall/FeaturesBox/PremiumSelection'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'

const STANDARD_TITLE = 'Standard'
const PREMIUM_TITLE = 'Premium'

type props = {
  isStandardList: boolean | true,
  className?: string,
  enableCompareMode?: boolean
  onChangeSelection?: (event) => void
  selectedInput?: PlanSelection
}

const FeaturesBox = ({
  isStandardList = true,
  className = '',
  enableCompareMode = false,
  onChangeSelection = () => { },
  selectedInput
}: props) => {
  const benefitList = isStandardList ? Benefits.STANDARD : Benefits.PREMIUM

  return (
    <S.Container className={className}>
      <S.TitleSection>
        <S.Title>{isStandardList ? STANDARD_TITLE : PREMIUM_TITLE}</S.Title>
      </S.TitleSection>

      <S.Content>
        {!isStandardList && (
          <S.AroundList>
            <i>All the features from STANDARD plus</i>
          </S.AroundList>
        )}

        <S.List>
          {benefitList.map((benefit) => (
            <S.Benefit key={benefit}>{benefit}</S.Benefit>
          ))}
        </S.List>

        {!isStandardList && (
          <S.AroundList>
            <i>and so much more...</i>
          </S.AroundList>
        )}
      </S.Content>

      {isStandardList && !enableCompareMode && <S.FreeBox>free</S.FreeBox>}

      {!isStandardList && !enableCompareMode && (
        <PremiumSelection
          {...{
            selectedInput,
            onChangeSelection
          }}
        />
      )}
    </S.Container>
  )
}

export default FeaturesBox

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 280px;
    border: 1px solid ${Brand.accentColor()};
    border-radius: 15px;
    background-color: ${color('paneBackground')};
  `,
  TitleSection: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${color('titleBackground')};
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
  `,
  Title: styled.div`
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
  `,
  Benefit: styled.li`
    margin: 10px 0 0 0;
    padding-right: 5px;
    padding-left: 5px;
  `,
  FreeBox: styled.div`
    background-color: ${color('premiumPlanSelectionUnchecked')};
    color: ${color('premiumFreeBoxText')};
    font-size: 18px;
    font-weight: bold;
    padding: 10px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    height: 72.5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    text-transform: uppercase;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px 10px 5px 15px;
    color: ${color('secondaryText')};
  `,
  AroundList: styled.div`
    margin: 10px 0;
    height: 25px;
    width: 100%;
    padding-left: 15px;
    display: flex;
  `,
  List: styled.ul`
    margin: 0;
  `
}
